import BonusModal from './BonusModal';

export default BonusModal;
